import { render, staticRenderFns } from "./Conferences_Liste.vue?vue&type=template&id=248b47a6&scoped=true&"
import script from "./Conferences_Liste.vue?vue&type=script&lang=js&"
export * from "./Conferences_Liste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248b47a6",
  null
  
)

export default component.exports